export default "<div *ngIf=\"loader$ | async\" class=\"loader-overlay\">\n  <ion-spinner name=\"crescent\"  color=\"danger\"></ion-spinner>\n</div>\n";